import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { aceAssignmentKeys } from '../../cache-keys/aceAssignmentKeys';

export function useGetAgentAssignmentV3(
  agentId: string,
  options?: Parameters<typeof useQuery>[2]
) {
  const api = useAPI();

  return useQuery({
    queryKey: [aceAssignmentKeys.agent(agentId)],
    queryFn: () => ace_api.getAgentAssignmentsV3(api)({ AgentID: agentId }),
    enabled: agentId !== '' && api.token !== '' && options?.enabled !== false,
  });
}
